(() => {
 if (window.cfSuperNovaeInitialized) return;
 window.cfSuperNovaeInitialized = true;
 const init = (scope = document) => {
  const roots = scope.matches?.('[data-sn-main]') ? [scope] : scope.querySelectorAll('[data-sn-main]');
  roots.forEach(root => {
   if (root.dataset.snReady) return;
   const variants = [...root.querySelectorAll('[data-sn-variant]')];
   const groups = [...root.querySelectorAll('[data-sn-size-group]')];
   const genders = [...root.querySelectorAll('[data-sn-gender]')];
   const price = root.querySelector('[data-sn-price]');
   const stickyPrice = root.querySelector('[data-sn-sticky-price]');
   const setGender = (gender, reset) => {
    groups.forEach(group => {
     const active = group.dataset.snSizeGroup === gender;
     group.hidden = !active;
     group.querySelectorAll('input').forEach(input => { input.disabled = !active || input.dataset.soldOut === 'true'; if (reset) input.checked = false; });
    });
    genders.forEach(button => button.setAttribute('aria-pressed', String(button.dataset.snGender === gender)));
    if (reset) { price.textContent = price.dataset.defaultPrice; stickyPrice.textContent = price.textContent; const url = new URL(location.href); url.searchParams.delete('variant'); history.replaceState({}, '', url); }
   };
   genders.forEach(button => button.addEventListener('click', () => { if(button.getAttribute('aria-pressed') !== 'true') setGender(button.dataset.snGender, true); }));
   variants.forEach(input => input.addEventListener('change', () => {
    if (!input.checked) return;
    price.textContent = input.dataset.price; stickyPrice.textContent = input.dataset.price;
    const url = new URL(location.href); url.searchParams.set('variant', input.value); history.replaceState({}, '', url);
   }));
   setGender(variants.find(input => input.checked)?.dataset.snGender || genders[0]?.dataset.snGender, false);
   root.querySelector('.cf-sn-gender-switch').hidden = false;
   const images = [...root.querySelectorAll('[data-sn-image]')];
   const image = root.querySelector('.cf-sn-hero-image img');
   const large = root.querySelector('[data-sn-large]');
   const gallery = root.querySelector('[data-sn-gallery]');
   let current = 0;
   const show = index => {
    current = (index + images.length) % images.length;
    const next = images[current]; image.src = next.dataset.src; image.srcset = next.dataset.srcset; image.alt = next.dataset.alt; large.href = next.dataset.src;
    images.forEach((button,i)=>button.setAttribute('aria-pressed', String(i===current)));
    root.querySelector('[data-sn-gallery-status]').textContent = `${current + 1} of ${images.length}: ${next.getAttribute('aria-label')}`;
   };
   images.forEach((button,i)=>button.addEventListener('click',()=>show(i)));
   root.querySelector('[data-sn-prev]').addEventListener('click',()=>show(current-1));
   root.querySelector('[data-sn-next]').addEventListener('click',()=>show(current+1));
   gallery.addEventListener('keydown',event=>{if(event.key==='ArrowRight'||event.key==='ArrowLeft'){event.preventDefault();show(current+(event.key==='ArrowRight'?1:-1));}});
   root.querySelector('.cf-sn-gallery-controls').hidden = false;
   root.dataset.snReady = 'true';
   const sticky = root.querySelector('[data-sn-sticky]');
   let scheduled = false, active = true;
   const update = () => { scheduled = false; if(active) sticky.hidden = root.querySelector('.cf-sn-form').getBoundingClientRect().bottom > 0; };
   const schedule = () => {if(!scheduled){scheduled=true;requestAnimationFrame(update);}};
   if(!window.Shopify?.designMode){window.addEventListener('scroll',schedule,{passive:true});window.addEventListener('resize',schedule,{passive:true});update();}
   sticky.querySelector('a').addEventListener('click',()=>{sticky.hidden=true;requestAnimationFrame(()=>root.querySelector('[data-sn-variant]:checked, [data-sn-variant]:not(:disabled)')?.focus({preventScroll:true}));});
   root.snCleanup=()=>{active=false;window.removeEventListener('scroll',schedule);window.removeEventListener('resize',schedule);};
  });
 };
 if(document.readyState==='loading') document.addEventListener('DOMContentLoaded',()=>init(),{once:true}); else init();
 document.addEventListener('shopify:section:load',event=>init(event.target));
 document.addEventListener('shopify:section:unload',event=>event.target.querySelectorAll('[data-sn-main]').forEach(root=>root.snCleanup?.()));
})();
